import React from "react";

const InlineLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="150"
      height="17"
      viewBox="0 0 150 17"
      fill="none"
      {...props}
    >
      <path
        d="M66.0686 7.11873L69.936 0.765137H67.726H66.3448L64.4111 4.3563L66.0686 7.11873Z"
        fill="#6061E5"
      />
      <path
        d="M64.1343 12.6437L66.2338 16.2349H68.278H69.6592L65.7918 9.60503L64.1343 12.6437Z"
        fill="#6061E5"
      />
      <path
        d="M0.211914 16.2348V0.765193H5.20639C9.69258 0.765193 12.5876 3.85912 12.5876 8.3895V8.5884C12.5876 13.1188 9.69258 16.2348 5.20639 16.2348H0.211914ZM5.18429 3.66022H3.41633V13.3398H5.18429C7.61523 13.3398 9.27269 11.6381 9.27269 8.5663V8.4558C9.27269 5.38398 7.61523 3.66022 5.18429 3.66022Z"
        fill="#231D2C"
      />
      <path
        d="M13.0902 16.2348L18.6372 0.676795H21.6869L27.2338 16.2348H23.9189L22.7698 12.8757H17.4438L16.3167 16.2348H13.0902ZM18.4162 10.047H21.7974L20.1178 5.00829L18.4162 10.047Z"
        fill="#231D2C"
      />
      <path
        d="M30.517 16.2348V3.72652H26.6275V0.765193H37.5888V3.72652H33.6993V16.2348H30.517Z"
        fill="#231D2C"
      />
      <path
        d="M36.9809 16.2348L42.5279 0.676795H45.5776L51.1246 16.2348H47.8096L46.6605 12.8757H41.3345L40.2074 16.2348H36.9809ZM42.3069 10.047H45.6881L44.0085 5.00829L42.3069 10.047Z"
        fill="#231D2C"
      />
      <path
        d="M65.2563 8.3232L60.527 16.2348H56.969L61.5436 8.3674L57.1679 0.765193H60.8143L65.2563 8.3232Z"
        fill="#231D2C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M71.9272 16.2348V0.765193H77.0764C80.546 0.765193 82.7338 2.77624 82.7338 6.06906V6.11326C82.7338 9.67127 80.1924 11.4613 76.9438 11.5276H75.1316V16.2348H71.9272ZM76.9217 8.6547H75.1316V3.66022H76.8775C78.5791 3.66022 79.5073 4.5442 79.5073 6.15746V6.17956C79.5073 7.61602 78.5791 8.6547 76.9217 8.6547Z"
        fill="#6061E5"
      />
      <path
        d="M84.8329 16.2348V0.765193H88.0374V13.2956H94.2915V16.2348H84.8329Z"
        fill="#6061E5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M102.076 16.5C97.9657 16.5 95.0928 13.2735 95.0928 8.6547V8.3895C95.0928 3.74862 98.0099 0.5 102.098 0.5C106.209 0.5 109.082 3.72652 109.082 8.3453V8.6105C109.082 13.2293 106.165 16.5 102.076 16.5ZM105.767 8.5884C105.767 11.6381 104.242 13.5387 102.098 13.5387C99.9547 13.5387 98.3856 11.616 98.3856 8.5663V8.4116C98.3856 5.36188 99.9105 3.46133 102.076 3.46133C104.22 3.46133 105.767 5.38398 105.767 8.4337V8.5884Z"
        fill="#6061E5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M111.616 16.2348V0.765193H117.428C119.218 0.765193 120.654 1.27348 121.627 2.24586C122.466 3.08563 122.93 4.3011 122.93 5.82597V5.91436C122.93 8.25691 121.759 9.73757 120.058 10.4889L123.35 16.2348H119.682L116.831 11.1519H114.82V16.2348H111.616ZM117.185 8.3232H114.82V3.66022H117.118C118.754 3.66022 119.704 4.4337 119.704 5.98066V6.00276C119.704 7.39503 118.82 8.3232 117.185 8.3232Z"
        fill="#6061E5"
      />
      <path
        d="M125.471 16.2348V0.765193H135.438V3.66022H128.653V6.99724H134.62V9.89227H128.653V13.3398H135.526V16.2348H125.471Z"
        fill="#6061E5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M138.053 16.2348V0.765193H143.865C145.655 0.765193 147.092 1.27348 148.064 2.24586C148.904 3.08563 149.368 4.3011 149.368 5.82597V5.91436C149.368 8.25691 148.197 9.73757 146.495 10.4889L149.788 16.2348H146.119L143.268 11.1519H141.257V16.2348H138.053ZM143.622 8.3232H141.257V3.66022H143.556C145.191 3.66022 146.141 4.4337 146.141 5.98066V6.00276C146.141 7.39503 145.257 8.3232 143.622 8.3232Z"
        fill="#6061E5"
      />
    </svg>
  );
};

export default InlineLogo;
